import { heroHotTags, heroStats, heroTicker } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20stylized%20editorial%20artwork%20of%20a%20shadowy%20crowded%20stage%20with%20warm%20amber%20spotlights%20cutting%20through%20atmospheric%20haze%2C%20dark%20charcoal%20gradient%20background%2C%20layered%20geometric%20shapes%20and%20blurred%20silhouettes%2C%20cinematic%20high%20contrast%20moody%20lighting%2C%20soft%20film%20grain%2C%20generous%20negative%20space%20in%20the%20center%2C%20no%20text%2C%20no%20faces&width=1600&height=900&seq=hlw-hero-01&orientation=landscape"
          alt="15黑料网 人物黑料档案主视觉"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70" />
      </div>

      <div className="relative w-full px-4 pb-14 pt-16 md:px-8 md:pb-20 md:pt-24 xl:px-14">
        <div className="mx-auto flex w-full max-w-4xl flex-col items-center text-center">
          <span className="hlw-reveal inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 font-label text-xs tracking-[0.18em] text-white/90 backdrop-blur">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-archive-2-line text-sm" />
            </span>
            人物黑料档案 · 按热度持续更新
          </span>

          <h1 className="hlw-reveal mt-6 font-heading text-4xl font-black leading-tight tracking-tight text-white md:text-6xl">
            15黑料网
            <span className="mt-2 block font-heading text-lg font-semibold tracking-[0.14em] text-white/85 md:text-2xl">
              人物黑料档案 · 黑历史合集
            </span>
          </h1>

          <p className="hlw-reveal mt-5 max-w-2xl text-sm leading-relaxed text-white/80 md:text-base">
            集中呈现公众人物黑历史、负面事件与争议合集。按人物索引快速定位，顺着完整事件脉络与多方信源整理，把来龙去脉一次看清。
          </p>

          <div className="hlw-reveal mt-8 w-full max-w-2xl">
            <div className="flex flex-col gap-2.5 rounded-lg border border-white/15 bg-white/10 p-2.5 backdrop-blur sm:flex-row sm:items-center">
              <div className="relative flex-1">
                <span className="pointer-events-none absolute left-3 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center text-white/60">
                  <i className="ri-search-line text-base" />
                </span>
                <input
                  type="text"
                  name="hero-archive-search"
                  placeholder="输入人物名或事件关键词，查黑料档案"
                  className="w-full rounded-md border border-white/10 bg-black/25 py-3 pl-10 pr-4 text-sm text-white outline-none transition-colors placeholder:text-white/55 focus:border-white/40"
                />
              </div>
              <button
                type="button"
                className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                查档案
              </button>
            </div>
            <div className="mt-3 flex flex-wrap items-center justify-center gap-2">
              {heroHotTags.slice(0, 5).map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-white/20 bg-white/5 px-3 py-1 font-label text-xs text-white/75"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="hlw-reveal mt-10 grid w-full max-w-2xl grid-cols-3 divide-x divide-white/15 rounded-lg border border-white/15 bg-black/25 backdrop-blur">
            {heroStats.map((stat) => (
              <div key={stat.label} className="flex flex-col items-center px-2 py-4">
                <span className="font-heading text-xl font-bold text-accent-300 md:text-2xl">
                  {stat.value}
                </span>
                <span className="mt-1 font-label text-[11px] text-white/70 md:text-xs">
                  {stat.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative w-full overflow-hidden border-t border-white/10 bg-black/40 py-3 backdrop-blur">
        <div className="hlw-marquee-track flex w-max items-center gap-10">
          {[...heroTicker, ...heroTicker].map((item, index) => (
            <span
              key={`${item}-${index}`}
              className="flex items-center gap-2 whitespace-nowrap font-label text-xs text-white/70"
            >
              <span className="flex h-4 w-4 items-center justify-center text-accent-300">
                <i className="ri-flashlight-line text-sm" />
              </span>
              {item}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}